export default "__VITE_ASSET__Cp8OJH$___"